import { render, staticRenderFns } from "./msgRelease.vue?vue&type=template&id=0a4731ee&scoped=true"
import script from "./msgRelease.vue?vue&type=script&lang=js"
export * from "./msgRelease.vue?vue&type=script&lang=js"
import style0 from "./msgRelease.vue?vue&type=style&index=0&id=0a4731ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4731ee",
  null
  
)

export default component.exports